import { Card, Col, Row, Typography } from "antd";
import { CompanyLogo } from "@bindeleddet/core/components";
import { message } from "@bindeleddet/core/utils";
import { Event } from "@bindeleddet/core/types";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import dayjs from "dayjs";
import { toCapitalCase } from "helpers/strings";
import { Link } from "react-router-dom";
import EventStatusBadge from "./EventStatusBadge/EventStatusBadge";

const { Title } = Typography;

interface Props {
  event: Event;
}

const EventCard: React.FC<Props> = ({ event }) => {
  const { currentUser } = useLoginContext();
  const eventPath = `/events/${event.id}/`;

  const handleEventClick = (linkEvent: React.MouseEvent<HTMLAnchorElement>) => {
    if (!currentUser) {
      linkEvent.preventDefault();
      return message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    }
    if (isCompanyUser(currentUser) && event.company.id !== currentUser.id) {
      linkEvent.preventDefault();
      return message("error", "Bedrifter kan kun åpne egne arrangementer");
    }
  };

  return (
    <Col>
      <Link
        to={eventPath}
        onClick={handleEventClick}
        style={{ display: "block", color: "inherit", textDecoration: "none" }}
      >
        <Card hoverable style={{ backgroundColor: "white" }}>
          <EventStatusBadge status={event.registration_status} />
          <CompanyLogo key={event.company.id} src={event.company.logo} companyId={event.company.id} size="20vh" />
          <Row style={{ padding: "1em 1em 0px", textAlign: "center" }} justify="center">
            <Title level={5} style={{ color: "rgb(5, 5, 5)" }}>
              {toCapitalCase(dayjs(event.start).format("dddd"))}
              <br />
              {dayjs(event.start).format("D. MMM")}
            </Title>
          </Row>
        </Card>
      </Link>
    </Col>
  );
};

export default EventCard;
